import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useState } from 'react';
import { RpmAccount } from '../../../../store/RpmAccount';
import { ComponentSpinner } from '../../Loading/ComponentSpinner';
import { TextBlock } from '../../../Atoms/Text';
import { SearchBox } from '../../Search/Search';
import { EntityType, SearchResult } from '../../../../store/Search';

export const EditRelationshipFieldData = {
  assignedRep: {
    title: 'Assign Rep',
    label: 'RPM Rep Assignment',
    entityType: 'RPM_REP',
    fieldId: 'assignedRepId'
  }
};

export const editRelationshipFields = Object.keys(EditRelationshipFieldData);

interface objects {
  allObjects: RpmAccount;
}

interface EditRelationshipModalProps {
  open: boolean;
  onClose: () => void;
  data: objects['allObjects'];
  onSave?: (data: objects['allObjects']) => void;
  field: string;
}

interface valueOption {
  id: string;
  name: string;
}

export const EditRelationshipModal = ({ open, onClose, data, onSave, field }: EditRelationshipModalProps) => {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState<valueOption | null>(null);
  const fieldData = EditRelationshipFieldData[field as keyof typeof EditRelationshipFieldData];

  const handleSelect = (result: SearchResult) => {
    const { id, matchedValue } = result;
    setValue({ id, name: matchedValue });
  };

  const handleSave = async () => {
    if (onSave) {
      setLoading(true);
      const newValues = {
        [fieldData.fieldId]: value?.id ?? null,
        [field]: value?.name ?? null
      };
      const updatedData = { ...data, ...newValues };
      if (newValues[fieldData.fieldId] != String(data[fieldData.fieldId as keyof objects['allObjects']]) || '') {
        await onSave(updatedData);
      }
      setLoading(false);
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.SubmitEvent) => {
            event.preventDefault();
            handleSave();
          },
          sx: { overflowY: 'visible' }
        }
      }}
      fullWidth
      maxWidth="xs"
      data-testid="edit-relationship-modal">
      §
      <DialogTitle>
        <TextBlock
          weight="bold"
          size="lg"
          color="grey9">
          {fieldData.title}
        </TextBlock>
      </DialogTitle>
      <DialogContent sx={{ minHeight: 70, overflowY: 'visible', paddingLeft: 8, paddingRight: 10 }}>
        {loading && <ComponentSpinner label="Saving..." />}
        {!loading && (
          <div className="space-y-3 justify-center mt-3">
            <TextBlock color="grey6">{fieldData.label}</TextBlock>
            <SearchBox
              handleSelect={handleSelect}
              searchEntityType={EntityType[fieldData.entityType as keyof typeof EntityType]}
              inputString=""
              fullWidth
              placeholder={String(data[field as keyof objects['allObjects']] || '')}
            />
          </div>
        )}
      </DialogContent>
      <hr className="mb-1 mx-6" />
      {!loading && (
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            data-testid="cancel-button"
            onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={!value}
            type="submit"
            variant="contained">
            Save
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
